export default __webpack_public_path__ + "static/tz-9b2b45fbd033a4af94c2dd2d50225b44.svg";